import { HowItWorks } from '../components/solutions/HowItWorks'
import { FeaturesCard } from '../components/solutions/FeaturesCard'
import Testimonial from '../components/Testimonial'
import GetStarted from '../components/GetStarted'

import MainLayout from './Main'

const SolutionsLayout = (props) => {
    return (
        <MainLayout>
            <div>
                {
                    props?.props?.children[props?.props?.children.length - 1]
                        ?.props?.children?.props?.children
                }
            </div>
            <div className="container">
                <div>
                    <HowItWorks />
                </div>
                <div className=" section">
                    <FeaturesCard />
                </div>
                {/* separator */}
                <div className="separator"></div>
                {/* =========== Testimonial =========== */}
                <div className="section">
                    <Testimonial />
                </div>
                {/* =========== Section Get Started =========== */}
                <div className="pt-0 section">
                    <GetStarted />
                </div>
            </div>
        </MainLayout>
    )
}

export default SolutionsLayout
